exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "body,html{height:100%}body{margin:0;-webkit-overflow-scrolling:touch}#root{height:100%;overflow-y:auto}", "", {"version":3,"sources":["/home/jenkins/agent/workspace/klarna-payments-hosted-payment-page/klarna-payments-hosted-payment-page_hpp-frontend/client/index.css"],"names":[],"mappings":"AAAA,UAAU,WAAW,CAAC,KAAK,SAAS,gCAAgC,CAAC,MAAe,YAAY,eAAe,CAAC","file":"index.css","sourcesContent":["body,html{height:100%}body{margin:0;-webkit-overflow-scrolling:touch}:global(#root){height:100%;overflow-y:auto}"],"sourceRoot":""}]);

// exports
